angular.module( 'acme.view.application.passes.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.controllers',
  'acme.view.application.passes.create.series',
  'acme.view.application.passes.create.settings'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreate = {
        name: 'application.passes.create',
        url: '/create',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'PassesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Pass Program',
          permissions: ['PASS_RANGES_CREATE']
        }
      },
      passesEdit = {
        name: 'application.passes.edit',
        url: '/:id/edit',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'PassesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Pass Program',
          permissions: ['PASS_RANGES_UPDATE']
        }
      };

    $stateProvider
      .state(passesCreate)
      .state(passesEdit);
});
